import type { Opportunity, PlanningStage, StageBand } from '@/lib/planning-types'

/**
 * De trappen in dezelfde stapelvolgorde als de banden in de balk, met de band
 * waarin ze getekend worden. De koppeling staat hier en niet in het scherm, zodat
 * een knop en zijn band nooit uit elkaar kunnen lopen.
 */
export const STAGE_FILTERS: { value: PlanningStage; band: StageBand }[] = [
  { value: 'WON', band: 'won' },
  { value: 'LIKELY', band: 'likely' },
  { value: 'POSSIBLE', band: 'possible' },
  { value: 'SPECULATIVE', band: 'speculative' },
]

const ORDER = STAGE_FILTERS.map((filter) => filter.value)

export const ALL_STAGES: PlanningStage[] = [...ORDER]

/** De laag waarin een kans zeker is: gewonnen werk gaat voor op zijn trap. */
export function stageOf(opportunity: Pick<Opportunity, 'status' | 'stage'>): PlanningStage {
  return opportunity.status === 'WON' ? 'WON' : opportunity.stage
}

export function countsIn(opportunity: Pick<Opportunity, 'status' | 'stage'>, stages: PlanningStage[]): boolean {
  return stages.includes(stageOf(opportunity))
}

/**
 * Aan- of uitzetten, altijd in de canonieke volgorde terug. De laatste trap kan
 * niet uit: de server weigert een lege keuze, en terecht - een vooruitblik die
 * overal nul meldt leest als een lege agenda in plaats van als een filter.
 */
export function toggleStage(stages: PlanningStage[], stage: PlanningStage): PlanningStage[] {
  const active = stages.includes(stage)
  if (active && stages.length === 1) return stages

  const next = active ? stages.filter((item) => item !== stage) : [...stages, stage]

  return ORDER.filter((item) => next.includes(item))
}

/**
 * Wat er op deze machine bewaard staat. Onbekende of lege inhoud valt terug op
 * alles: een kapotte voorkeur mag nooit werk uit beeld houden.
 */
export function readStages(raw: string | null): PlanningStage[] {
  const stored = (raw ?? '').split(',').map((token) => token.trim().toUpperCase())
  const chosen = ORDER.filter((stage) => stored.includes(stage))

  return chosen.length > 0 ? chosen : [...ALL_STAGES]
}
